import React from 'react';
import { SITE } from '../mock';
import SEO from '../components/SEO';

function LegalShell({ title, path, children }) {
  return (
    <div className="pt-36 pb-24 px-6 lg:px-10">
      <SEO path={path} title={title} description={`${title} – Moonshine Solutions GmbH. Rechtliche Informationen.`} />
      <div className="max-w-3xl mx-auto">
        <div className="text-xs uppercase tracking-[0.28em] text-[#d4b574] mb-4">Rechtliches</div>
        <h1 className="font-serif-display text-5xl md:text-6xl text-[#f5efe3] leading-[1.05]">{title}</h1>
        <div className="divider-gold my-10" />
        <div className="space-y-4 text-[#cfc6b5] leading-relaxed text-[15px]">{children}</div>
      </div>
    </div>
  );
}

export function Impressum() {
  return (
    <LegalShell title="Impressum" path="/impressum">
      <p><strong className="text-[#e8d5a8]">{SITE.brandFull}</strong></p>
      <p>Geschäftsführer: {SITE.ceo}<br />Schweiz</p>
      <p>E-Mail: <a href={`mailto:${SITE.email}`} className="text-[#e8d5a8] hover:underline">{SITE.email}</a></p>
      <p>Web: moonshine-solutions.com</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">Haftungsausschluss</h2>
      <p>Der Autor übernimmt keinerlei Gewähr hinsichtlich der inhaltlichen Richtigkeit, Genauigkeit, Aktualität, Zuverlässigkeit und Vollständigkeit der Informationen.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">Haftung für Links</h2>
      <p>Verweise und Links auf Webseiten Dritter liegen ausserhalb unseres Verantwortungsbereichs. Es wird jegliche Verantwortung für solche Webseiten abgelehnt.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">Urheberrechte</h2>
      <p>Die Urheber- und alle anderen Rechte an Inhalten, Bildern, Fotos oder anderen Dateien auf der Website gehören ausschliesslich der {SITE.brandFull} oder den speziell genannten Rechtsinhabern.</p>
    </LegalShell>
  );
}

export function Datenschutz() {
  return (
    <LegalShell title="Datenschutz" path="/datenschutz">
      <p>Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst und behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">Erhebung von Daten</h2>
      <p>Die Nutzung unserer Webseite ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten (beispielsweise Name, Anschrift oder E-Mail-Adressen) erhoben werden, erfolgt dies, soweit möglich, stets auf freiwilliger Basis.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">Cookies</h2>
      <p>Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">Kontakt</h2>
      <p>Bei Fragen zum Datenschutz: <a href={`mailto:${SITE.email}`} className="text-[#e8d5a8] hover:underline">{SITE.email}</a></p>
    </LegalShell>
  );
}

export function AGB() {
  return (
    <LegalShell title="AGB" path="/agb">
      <p>Allgemeine Geschäftsbedingungen der {SITE.brandFull}.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">1. Geltungsbereich</h2>
      <p>Diese AGB gelten für alle Verträge zwischen der {SITE.brandFull} und ihren Kundinnen und Kunden.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">2. Leistungen</h2>
      <p>Die {SITE.brandFull} erbringt Beratungsleistungen in den Bereichen Vermögensaufbau, Immobilien, Alphalane AI Trading, Vorsorge und Edelmetalle.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">3. Vertraulichkeit</h2>
      <p>Wir behandeln alle uns anvertrauten Daten vertraulich und geben diese nicht an Dritte weiter, sofern keine ausdrückliche Einwilligung vorliegt.</p>
      <h2 className="font-serif-display text-2xl text-[#f5efe3] mt-8">4. Schlussbestimmungen</h2>
      <p>Es gilt ausschliesslich schweizerisches Recht. Gerichtsstand ist der Sitz der Gesellschaft.</p>
    </LegalShell>
  );
}
